import React from 'react';

import { CircularProgress } from '@mui/material';
import Stack from '@mui/material/Stack';

/**
 * 공용 로딩 스피너
 */
function LoadingSpinner({ size = 40 }: { size?: number }) {
  return (
    <Stack alignItems={'center'} justifyContent={'center'} height={'100%'}>
      <CircularProgress size={size} />
    </Stack>
  );
}

export default React.memo(LoadingSpinner);
